export default "__VITE_ASSET__DOr68rHZ__"